// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"273":"585e4224de499b1e","496":"46dbb6c71b51853d","871":"29e4380314a55aee"}[chunkId] + ".js";
};